// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

// Keep these in sync with the back-end enums.

export enum SecurityRequestType {
    RECOVERY_KEY = 'recovery-key',
    ADD_APPROVER = 'add-approver',
    REMOVE_APPROVER = 'remove-approver',
    DISK_CONFIG = 'disk-config',
    BITLOCKER_KEY = 'bitlocker-key'
}

export enum SecurityRequestStatus {
    PENDING = 'pending',
    APPROVED = 'approved',
    DENIED = 'denied',
    CANCELLED = 'cancelled',
    ACCEPTED = 'accepted',
}

export enum SecurityRequestResult {
    APPROVED = 'approved',
    DENIED = 'denied',
}

export enum SecurityApproverState {
    NOT_APPROVER = 0,
    APPROVER = 1,
    APPROVER_PENDING = 2,
    NOT_APPROVER_PENDING = 3,
}

export enum PostSecurityResponseStatus {
    SUCCESS = 0,
    MISSING_TYPE_OR_TARGET = 1,
    INVALID_REQUEST_TYPE = 2,
    TARGET_USER_INVALID_OR_INACTIVE = 3,
    USER_TARGET_USER_GROUP_MISMATCH = 4,
    RECOVERY_KEY_DISABLED = 5,
    DISK_CONFIG_NON_CUSTOMER = 6,
    BITLOCKER_KEY_NON_CUSTOMER = 7,
    ADD_APPROVER_INVALID_APPROVER_STATUS = 8,
    REMOVE_APPROVER_INVALID_APPROVER_STATUS = 9,
    ATTEMPTED_REMOVAL_OF_LAST_APPROVER = 10,
    EXISTING_PENDING_OR_APPROVED_REQUEST = 11,
    EXISTING_ACCEPTED_REQUEST = 12,
}


export interface IApproverResponseResult {
    firstName: string;
    lastName: string;
    email: string;
    userId: number;
}

export interface IApproversResponse {
    success: boolean;
    results: IApproverResponseResult[];
}

export interface IApproversStatusResult extends IApproverResponseResult {
    status: SecurityRequestStatus;
}

export interface IApproversStatusResponse {
    success: boolean;
    results: IApproversStatusResult[];
}

export interface ISecurityRequest {
    created_dttm: string;
    id: number;
    target_email: string;
    type: SecurityRequestType;
    status: SecurityRequestStatus;
}

export interface ISecurityRequestToApprove {
    success: boolean;
    found: boolean;
    request?: {
        id: number;
        type: string;
    },
    target?: {
        id: number;
        email: string;
    },
    source?: {
        id: number;
        email: string;
    }
}

export interface ISecurityRequestPost {
    type: SecurityRequestType;
    target_id: number;
    target_disk_serial?: string;
    data?: { [key: string]: string };
    email_approvers?: boolean;
}

export interface ISecurityRequestResponse {
    success: boolean;
    found: boolean;
    id?: number;  // Security request ID
    accepted?: string;
    userId?: number;
    status: SecurityRequestStatus;
}

export interface ISecurityResultResponse {
    success: boolean;
    alreadyApproved?: boolean;
    alreadyVoted?: boolean;
    notPending?: boolean;
    recoveryKeyDisabled?: boolean;
}

export enum SecurityApprovalMethod {
    PERCENT_RULE = 0,
    PLUS_ONE_RULE = 1
}
